import React, {useEffect} from 'react';
import styles from "../CurrentProposal/CurrentProposal.module.css";
import GoBack from "../subsidiary/GoBack/GoBack";
import Loader from "../subsidiary/Loader/Loader";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {fetchCurrentProposal} from "../Proposal/proposalSlice";
import Sharing from "../Rating/Sharing";

function CurrentProposal(props) {
    const id = useParams().id
    const dispatch = useDispatch()
    const isLoaded = useSelector(state => state.proposalSlice.isLoaded)
    const data = useSelector(state => state.proposalSlice.currentProposal)
    const likes = data?.likes_count
    const sharing = data?.sharings_count
    const date = moment(data.created_at).format('DD MMM YYYY')
    const isProposal = window.location.pathname.split('/')[1] === 'proposal'
    useEffect(() => {
        if (isProposal) {
            dispatch(fetchCurrentProposal(id))
        }
    },[dispatch, isProposal, id])

    return (
        <>
            {isLoaded && data.media ?
                <div className="content-wrapper">
                    <section className={styles.news + ' main'}>
                        <div className={styles.wrapper}>
                            <GoBack text={date} />
                            <div className={styles.img} style={{
                                background: `${data.media.image ? `linear-gradient(0deg, rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.38)), url(${data.media.image})` : 'black'}`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover'
                            }}>
                                <div style={{ padding: '30px' }}>
                                    <h1 className={styles.title}>
                                        {data.name}
                                    </h1>
                                    {/*<div className={styles.tags}>*/}
                                    {/*    {data.tags.map(tag => {*/}
                                    {/*        return <span className={styles.tag}>{tag.text}</span>*/}
                                    {/*    })*/}
                                    {/*    }*/}

                                    </div>
                                </div>
                            {/*</div>*/}
                            <div className="content-wrapper">
                                <div className={styles.sharingContainer}>
                                    <Sharing type={'proposal'} position={'current'} likes={likes} sharing={sharing} isLiked={data.is_liked}  id={id}/>
                                </div>
                                {data.text ? <div dangerouslySetInnerHTML={{ __html: data.text }} className={styles.textContent}>
                                </div> : <div>Текста нет</div>}
                            </div>
                        </div>
                    </section>
                </div> : <Loader />}
        </>
    );
}

export default CurrentProposal;